import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 145,
    height: 78
  }
});

class MybilioTextLogoBronze extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 145 78" } >
      <path d="M60.3102 75.4654L57.5104 61.5294L52.4285 75.6301H52.1932L47.0878 61.5294L44.3115 75.4654H43.3469L46.7819 58.7988H47.0407L52.3109 73.488L57.581 58.7988H57.8398L61.2748 75.4654H60.3102Z" fill="white"/>
      <path d="M70.8503 69.6509V75.4654H69.9092V69.6509L63.9803 58.9871H65.0625L70.3797 68.7799L75.6969 58.9871H76.7792L70.8503 69.6509Z" fill="white"/>
      <path d="M88.9596 66.52C89.9713 65.7667 90.5595 64.6132 90.5595 63.2479C90.5595 61.0116 88.9831 58.9871 85.7363 58.9871H81.1956V75.4654H86.5833C89.9478 75.4654 91.7123 73.1349 91.7123 70.7337C91.7123 68.7563 90.63 67.2498 88.9596 66.52ZM85.5952 61.1763C87.2892 61.1763 88.3008 62.1179 88.3008 63.4598C88.3008 64.7545 87.2656 65.8373 85.5717 65.8373H83.4307V61.1763H85.5952ZM86.4186 73.2761H83.4307V68.0501H86.4186C88.3008 68.0501 89.3831 69.1801 89.3831 70.6396C89.3831 72.0991 88.2773 73.2761 86.4186 73.2761Z" fill="white"/>
      <path d="M97.196 75.4654H99.4311V58.9871H97.196V75.4654Z" fill="white"/>
      <path d="M107.918 73.2761V58.9871H105.683V75.4654H114.012V73.2761H107.918Z" fill="white"/>
      <path d="M118.628 75.4654H120.863V58.9871H118.628V75.4654Z" fill="white"/>
      <path d="M134.997 75.7714C140.103 75.7714 143.443 71.8166 143.443 67.2262C143.443 62.6594 140.103 58.7046 134.997 58.7046C129.868 58.7046 126.527 62.6594 126.527 67.2262C126.527 71.8166 129.868 75.7714 134.997 75.7714ZM134.997 73.5586C131.28 73.5586 128.809 70.5925 128.809 67.2262C128.809 63.8599 131.28 60.9174 134.997 60.9174C138.691 60.9174 141.208 63.8599 141.208 67.2262C141.208 70.5925 138.691 73.5586 134.997 73.5586Z" fill="white"/>
      <path d="M1.55914 20.672V60.7211L34.1218 76.5161V74.531H34.1042V38.536L66.6864 20.5219L33.5352 1.56006L33.5254 6.87966V7.82151V36.3617L1.55914 20.672ZM34.1062 36.352V4.02096L62.9132 20.5375L34.1062 36.352ZM3.50807 23.7998L33.5215 38.534V74.0416L3.50807 59.5043V23.7998Z" fill="white"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(MybilioTextLogoBronze);